import { fetchSaveOffice } from "../../faetures/fetchSave";
import { useState, useEffect } from "react";


function OfficeSelect({value, setValue}) {
    const [listOptions, setListOptions] = useState([]);

    useEffect(() => {
        const Admin = sessionStorage.getItem('admin') === 'admin';
        const Office = localStorage.getItem('office_number');

        const fetchData = async () => {
            if (Admin) {
                try {
                    const resolve = await fetchSaveOffice();
                    setListOptions(resolve);
                } catch (error) {
                    setListOptions([]);
                }
            } else {
                setListOptions([Office]);
            }
        }

        fetchData();
    }, [])

    const changeSelect = (e) => {
        setValue(e.target.value);
    }

    return (
        <select value={value} onChange={changeSelect}>
            {listOptions && listOptions.length > 1 && <option value={'*'}> הכל </option>}
            
            {
                listOptions.map((value, key) => (
                    <option key={key} value={value}> {value} </option>
                ))
            }
        </select>
    )
}


export default OfficeSelect;